import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledSubCardActivity,
  Col,
  ActivityNumber,
  ActivityTitle,
} from './style';
import { Badge, Icon, Inline, Text } from '../../../atoms';
import SubCardActivityQuiz from '../SubCardActivityQuiz';
import theme from '../../../theme';
import { formatActivityInfo, timestampToDate } from '../../../../utils/common';
import { getFilterLabel } from '../../../../utils/labels';

const SubCardSession = ({ activity }) => {
  // QUIZ
  if (activity?.type === 'quiz') {
    const getDuration = (act) => {
      if (!(act?.start_time > 0 && act?.end_time > 0)) return '-';
      return act.end_time - act.start_time;
    };
    return (
      <StyledSubCardActivity>
        <Col>
          <Inline columnGap="24px">
            <ActivityNumber />
            <Badge type="news" uppercase>
              {getFilterLabel(activity?.type)}
            </Badge>
          </Inline>
          <Inline columnGap="19px">
            <ActivityTitle>{activity?.title}</ActivityTitle>
          </Inline>
        </Col>
        <Col>
          <Text type="statistics-heading">Completamento</Text>
          <Badge
            color={theme().colors.badgeActive}
            backgroundColor={theme().colors.badgeLightBlueBg}
            fontWeight="600"
          >
            <Inline columnGap="8px">
              {activity?.percentage > 0 ? 'Sì' : 'No'}
              <Icon
                type={activity?.percentage ? 'check-circle' : 'x-circle'}
                size={18}
                stroke={theme().colors.badgeActive}
                clickable={false}
              />
            </Inline>
          </Badge>
        </Col>
        <Col>
          <Inline columnGap="32px" justifyContent="space-between">
            <Inline columnGap="8px">
              <Icon
                type="calendar"
                size={18}
                stroke={theme().colors.primaryDarkGray700}
                clickable={false}
              />
              <Text type="statistics-heading">Data/ora inizio</Text>
            </Inline>
            <Text type="b4" className="date">
              {timestampToDate(activity?.start_time, 'DD/MM/YYYY - HH:mm') ||
                '-'}
            </Text>
          </Inline>
          <svg
            width="18"
            height="23"
            viewBox="0 0 2 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 0.5V22.5"
              stroke={theme().colors.primaryDarkGray700}
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeDasharray="3 3"
            />
          </svg>
          <Inline columnGap="32px" justifyContent="space-between">
            <Inline columnGap="8px">
              <Icon
                type="calendar-check-01"
                size={18}
                stroke={theme().colors.primaryDarkGray700}
                clickable={false}
              />
              <Text type="statistics-heading">Data/ora fine</Text>
            </Inline>
            <Text type="b4" className="date">
              {timestampToDate(activity?.end_time, 'DD/MM/YYYY - HH:mm') || '-'}
            </Text>
          </Inline>
        </Col>
        <SubCardActivityQuiz
          subType="quiz"
          activity={{
            ...activity,
            duration: getDuration(activity),
            quiz_tentatives: activity?.tentatives_done,
            quiz_score: Math.round(activity.percentage * 100),
          }}
        />
      </StyledSubCardActivity>
    );
  }
  // SESSION
  const info = formatActivityInfo(activity);
  return (
    <StyledSubCardActivity>
      <Col>
        <Inline columnGap="24px">
          <ActivityNumber />
          <Badge type="news" uppercase>
            {getFilterLabel(activity?.type)}
          </Badge>
        </Inline>
        <Inline columnGap="19px">
          <ActivityTitle>{activity?.title}</ActivityTitle>
        </Inline>
      </Col>
      <Col>
        <Text type="statistics-heading">Completamento</Text>
        <Badge
          color={theme().colors.badgeActive}
          backgroundColor={theme().colors.badgeLightBlueBg}
          fontWeight="600"
        >
          <Inline columnGap="8px">
            {activity?.completion ? 'Sì' : 'No'}
            <Icon
              type={activity?.completion ? 'check-circle' : 'x-circle'}
              size={18}
              stroke={theme().colors.badgeActive}
              clickable={false}
            />
          </Inline>
        </Badge>
      </Col>
      <Col>
        <Inline columnGap="32px" justifyContent="space-between">
          <Inline columnGap="8px">
            <Icon
              type="calendar"
              size={18}
              stroke={theme().colors.primaryDarkGray700}
              clickable={false}
            />
            <Text type="statistics-heading">Data/ora inizio</Text>
          </Inline>
          <Text type="b4" className="date">
            {timestampToDate(info.tsStart, 'DD/MM/YYYY - HH:mm') || '-'}
          </Text>
        </Inline>
        <svg
          width="18"
          height="23"
          viewBox="0 0 2 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 0.5V22.5"
            stroke={theme().colors.primaryDarkGray700}
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeDasharray="3 3"
          />
        </svg>
        <Inline columnGap="32px" justifyContent="space-between">
          <Inline columnGap="8px">
            <Icon
              type="calendar-check-01"
              size={18}
              stroke={theme().colors.primaryDarkGray700}
              clickable={false}
            />
            <Text type="statistics-heading">Data/ora fine</Text>
          </Inline>
          <Text type="b4" className="date">
            {timestampToDate(info.tsEnd, 'DD/MM/YYYY - H:mm') || '-'}
          </Text>
        </Inline>
      </Col>
      <div className="participation-info">
        <div className="d-flex sb">
          <Text type="h3.5">ISCRIZIONE</Text>
          <Text type="h3.5">{activity?.is_registered ? 'Sì' : 'No'}</Text>
        </div>
        <div className="d-flex sb">
          <Text type="h3.5">REGISTRAZIONE</Text>
          <Text type="h3.5">
            {' '}
            {activity?.attendance === 'without_attendance'
              ? 'Senza appello'
              : 'Con appello'}
          </Text>
        </div>
      </div>
    </StyledSubCardActivity>
  );
};

SubCardSession.propTypes = {
  activity: PropTypes.object,
};

export default SubCardSession;
